/**
 * Diese Klasse stellt Funktionen für das Durchführen von HTTP-Requests
 * zur Verfügung.
 */
export class RequestService {
	/**
	 * Diese Funktion mit der Hilfe von XMLHttpRequest ein Post-Request aus.
	 *
	 * @param {String} url An diese URL wird der Post-Request versendet
	 * @param {Object} data Diese Daten werden zusätzlich mit dem Post-Request mit versendet.
	 * @returns {Promise}
	 */
	static post(url, data = {}) {
		return new Promise((resolve, reject) => {
			let request = new XMLHttpRequest();
			request.open('POST', url, true);
			request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			request.withCredentials = true;
			request.addEventListener('readystatechange', () => {
				if (request.readyState !== 4) {
					return;
				}

				let response = {
					status: request.status,
					response: request.response,
					responseText: request.responseText,
					responseType: request.responseType,
					responseURL: request.responseURL
				};
				if (request.status == '200') {
					resolve(response);
				} else {
					reject(response);
				}
			});
			let urlEncodedData = RequestService.encodeUrlData(data);
			request.send(urlEncodedData);
		});
	}

	/**
	 * Diese Funktion mit der Hilfe von XMLHttpRequest ein Post-Request
	 * bei der eine Datei hochgeladen wird.
	 *
	 * @param {String} url An diese URL wird der Post-Request versendet
	 * @param {Object} data Diese Daten werden zusätzlich mit dem Post-Request mit versendet.
	 * @returns {Promise}
	 */
	static upload(url, data = {}) {
		return new Promise((resolve, reject) => {
			let request = new XMLHttpRequest();
			request.open('POST', url, true);
			request.withCredentials = true;
			request.addEventListener('readystatechange', () => {
				if (request.readyState !== 4) {
					return;
				}

				let response = {
					status: request.status,
					response: request.response,
					responseText: request.responseText,
					responseType: request.responseType,
					responseURL: request.responseURL
				};
				if (request.status == '200') {
					resolve(response);
				} else {
					reject(response);
				}
			});
			request.send(data);
		});
	}

	/**
	 * Diese Funktion mit der Hilfe von XMLHttpRequest ein Get-Request aus.
	 *
	 * @param {String} url An diese URL wird der Get-Request versendet
	 * @param {Object} data Diese Daten werden zusätzlich and die URL mitversendet
	 * @returns {Promise}
	 */
	static get(url, data = {}) {
		return new Promise((resolve, reject) => {
			for(let name in data) {
				url = RequestService.setUrlParameter(name, data[name], url);
			}

			let request = new XMLHttpRequest();
			request.open('GET', url, true);
			request.overrideMimeType('application/json');
			request.addEventListener('readystatechange', () => {
				if (request.readyState !== 4) {
					return;
				}

				let response = {
					status: request.status,
					response: request.response,
					responseText: request.responseText,
					responseType: request.responseType,
					responseURL: request.responseURL
				};
				if (request.status == '200') {
					resolve(response);
				} else {
					reject(response);
				}
			});
			request.send(null);
		});
	}

	/**
	 * Encoded ein Objekt in ein Key-Value-Pair.
	 *
	 * @param {Object} data
	 * @returns {String}
	 */
	static encodeUrlData(data) {
		let urlEncodedDataPairs = [];
		for(let name in data) {
			urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
		}
		return urlEncodedDataPairs.join('&');
	}

	/**
	 * Diese Funktion setzt der URL ein Query-Parameter.
	 * Wenn der Wert bereits vorhanden ist, dann wird dieser mit dem neuen Wert ersetzt.
	 * Ist der Wert noch nicht vorhanden, dann wird dieser der URL angefügt.
	 *
	 * @param {String} name Das Attribute mit diesem Namen wird überschrieben.
	 * @param {String} value Das Attribute wird mit diesem Wert überschrieben.
	 * @param {String} url In diese URL wird der Attribute überschrieben.
	 * @returns {String}
	 */
	static setUrlParameter(name, value, url) {
		if (!url || !name) {
			return;
		}
	
		name = encodeURIComponent(name);
		value = encodeURIComponent(value);
	
		let reg = new RegExp('([?&])' + name + '=.*?(&|$)', 'i');
		if (url.match(reg)) {
			return url.replace(reg, '$1' + name + '=' + value + '$2');
		} else {
			let separator = url.indexOf('?') !== -1 ? '&' : '?';
			return url + separator + name + '=' + value;
		}
	}
	
	/**
	 * Mit dieser Funktion kann ein Attribute aus einer URL
	 * rausgeladen werden.
	 *
	 * @param {String} name Name vom URL-Attribute
	 * @param {String} url Von dieser URL werden die Attribute ausgewertet
	 * @returns {String}
	 */
	static getUrlParameter(name, url) {
		url = url || document.URL;
		if (url.length > 0 && name.length > 0) {
			name = name + '=';
			let begin = url.indexOf(name);
			if (begin != -1) {
				begin += name.length;
				let end = url.indexOf('&', begin);
				if (end == -1) {
					end = url.length;
				}
				return decodeURIComponent(url.substring(begin, end));
			}
		}
		return null;
	}

	/**
	 * Diese Funktion läst alle Query-Parameter aus und gibt diese als Objekt zurück.
	 *
	 * @param {String} url Von dieser URL werden die Parameter ausgelesen
	 * @return {Object}
	 */
	static getUrlParameters(url) {
		let queryParameters = {};
		let queryString     = url.split('?');
		if (queryString.length <= 1) {
			return queryParameters;
		}

		queryString.pop().split('&').forEach((queryParameter) => {
			let pair = queryParameter.split('=');
			let name = decodeURIComponent(pair[0]).trim().replace(/[^a-z0-9\-_[]]/i, '');
			let value = decodeURIComponent(pair[1]);
			if (name) {
				queryParameters[name] = value;
			}
		});

		return queryParameters;
	}
}
